/***
 *
 *   HEADER
 *   Header section with title used in main application (can render children)
 *
 *   PROPS
 *   title: title of the view
 *   children: children to render (optional)
 *
 **********/

import { AuthContext } from "app/auth";
import axios from "axios";
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Style from "./header.module.scss";

export function Header(props) {
  const location = useLocation();
  const Auth = useContext(AuthContext);

  const checkDisabled = async () => {
    const agencyData = await axios.get("/api/account");

    if (agencyData.data.data.status === "total_disabled") {
      Auth.signout();
    } else {
      return false;
    }
  };

  useEffect(() => {
    checkDisabled();
  }, [location]);

  return (
    <header className={Style.header}>
      {props.title && (
        <div style={{ justifyContent: "flex-start" }}>
          <h1>
            COVER
            <span>BADGER</span>
          </h1>
        </div>
      )}

      {window && !window.location.toString().includes("/app/resources") && (
        <div
          style={{
            justifyContent: "center",
            color: "black",
            fontStyle: "italic",
          }}
        >
          <span>Have a question? Please visit</span>
          <span
            style={{ color: "red", cursor: "pointer" }}
            onClick={() => (window.location = "/app/resources")}
          >
            &nbsp;Resources Center
          </span>
        </div>
      )}
      <div
        style={{ alignItems: "flex-end", backgroundColor: "black", zIndex: -1 }}
      >
        {props.children}
      </div>
    </header>
  );
}
